export const deslugify = (slug) => {
  if (!slug || typeof slug !== "string") return "";

  const text = slug.replace(/-/g, " "); // Replace hyphens with spaces

  // Capitalize only the first word
  return text.charAt(0).toUpperCase() + text.slice(1).toLowerCase();
};
